export * from 'server/models/DeclarationOfSecurity';


// WEBPACK FOOTER //
// ./data/models/DeclarationOfSecurity.ts